import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import UserIcon from "../../../icons/UserIcon";
import HeartSvg from "../../../icons/HeartSvg";
import LoginSvg from "../../../icons/LoginSvg";
import ChevronDownSvg from "../../../icons/ChevronDownSvg";
import ChevronUpSvg from "../../../icons/ChevronUpSvg";
import { useState } from "react";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { clearAuth, clearBidderAuth, clearGuestUser } from "store";
import { AuthModalWrapper } from "../../../components/web/Auth/AuthModal";
import { useSelector } from "react-redux";
import { useGetProfileDetails } from "../../../hoc";
import { getWatermarkedImgixUrl } from "services";
interface props {
  userLoggedin: any;
}

export function UserNav({ userLoggedin }: props) {
  const { picture } = useGetProfileDetails();
  const onboardingData = useSelector((state: any) => state.auth.onboarding);
  const router = useRouter();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [authModelOpen, setAuthModelOpen] = useState(false);

  const handleLogout = async () => {
    await fetch("/api/logout", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    dispatch(clearAuth());
    dispatch(clearGuestUser());
    dispatch(clearBidderAuth());
    router.push("/");
  };
  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          setDropdownOpen(open);
        }}
      >
        <DropdownMenuTrigger asChild>
          <div className="flex items-center hover:cursor-pointer">
            <Button variant="ghost" className="relative h-8 w-8 rounded-full">
              <Avatar className="h-8 w-8">
                {picture && (
                  <AvatarImage
                    src={getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${picture}?fit=crop&w=32&h=32&auto=format`,
                    )}
                    alt="user"
                  />
                )}
                <AvatarFallback>
                  {userLoggedin && onboardingData?.name ? (
                    <p className="bg-brand-orange h-8 w-8 font-openSans font-semibold uppercase text-web-body-sm leading-4 text-white py-2">
                      {onboardingData?.name.charAt(0)}
                    </p>
                  ) : (
                    <UserIcon height="32" width="32" />
                  )}
                </AvatarFallback>
              </Avatar>
            </Button>
            {dropdownOpen ? <ChevronUpSvg /> : <ChevronDownSvg />}
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-52  pb-[14px] pt-[9px] px-5 mt-4 gap-x-3"
          align="end"
          forceMount
        >
          {userLoggedin && (
            <>
              <DropdownMenuItem
                onClick={() => router.push("/dashboard/profile")}
              >
                <UserIcon height="20" width="20" bg_color="#EFEFEF" />
                <p className="ml-[11px] font-openSans font-normal text-web-body-md leading-4 text-[#A8A8A8]">
                  Profile
                </p>
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => router.push("/dashboard/shortlisted")}
              >
                <HeartSvg height="20" width="20" bg_color="#EFEFEF" />
                <p className="ml-[11px] font-openSans font-normal text-web-body-md leading-4 text-[#A8A8A8]">
                  Shortlisted
                </p>
              </DropdownMenuItem>
            </>
          )}

          {userLoggedin ? (
            <DropdownMenuItem onClick={() => handleLogout()}>
              <LoginSvg height="20" width="20" bg_color="#EFEFEF" />
              <p className="ml-[11px] font-openSans font-normal text-web-body-md leading-4 text-[#A8A8A8]">
                Log out
              </p>
            </DropdownMenuItem>
          ) : (
            <DropdownMenuItem onClick={() => setAuthModelOpen(true)}>
              <LoginSvg height="20" width="20" bg_color="#EFEFEF" />
              <p className="ml-[11px] font-openSans font-normal text-web-body-md leading-4 text-[#A8A8A8]">
                Login/Register
              </p>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <AuthModalWrapper
        userLoggedin={userLoggedin}
        authModelOpen={authModelOpen}
        setAuthModelOpen={setAuthModelOpen}
      />
    </>
  );
}
